import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { notifySuccess } from '../services/notify';
import type { RelativitySettingsField, RelativitySettingsItem } from '../types/relativitySettings';

export type { RelativitySettingsField, RelativitySettingsItem };

export function useRelativitySettingsList(projectId: string, enabled = true) {
  return useQuery({
    queryKey: ['relativity-settings', projectId],
    queryFn: () => api.get<RelativitySettingsItem[]>(`/project/${projectId}/relativity/settings`),
    enabled: !!projectId && enabled,
  });
}

export function useSaveRelativitySettings(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (settings: RelativitySettingsItem) =>
      settings.id
        ? api.put(`/project/${projectId}/relativity/settings/${settings.id}`, { ...settings, projectId })
        : api.post(`/project/${projectId}/relativity/settings`, { ...settings, projectId }),
    onSuccess: (_data, variables) => {
      // Angular reused the "Load File Format" title for Relativity settings — preserve it.
      notifySuccess({ title: `Load File Format ${variables.id ? 'updated' : 'added'} successfully`, timeout: 2500 });
      qc.invalidateQueries({ queryKey: ['relativity-settings', projectId] });
    },
  });
}

export function useRelativityIioFields(projectId: string) {
  return useQuery({
    queryKey: ['relativity-iio-fields', projectId],
    queryFn: () => api.get<RelativitySettingsField[]>(`/project/${projectId}/relativity/settings/iio/fields`),
    enabled: !!projectId,
  });
}
